import { Dispatch, SetStateAction, useState } from "react";

import { useTranslation } from "react-i18next";

import { getScheduleTitle } from "@/shared/functions/functions";

import { MenuAnchorEl, ROUTES, TABLE_NAMES } from "../../../../../../../shared";
import { ScheduleDto } from "../../../../../types";
import SingleDetailsAcordionItem from "../../AccordionDetailsCard/components/SingleDetailsAcordionItem";
import RemoveScheduleButton from "../../ScheduleActions/RemoveSchedule/RemoveScheduleButton";
import ScheduleDetailsButton from "../../ScheduleActions/ScheduleDetails/ScheduleDetailsButton";
import ScheduleDetailsCardContent from "../ScheduleDetailsCardContent/ScheduleDetailsCardContent";

interface IVehicleScheduleDetailsSingleCardProps {
  route: ROUTES;
  schedule: ScheduleDto;
  index: number;
  totalCount: number;
  canManageSchedules: boolean;
  setIsLoading?: Dispatch<SetStateAction<boolean>>;
}

const VehicleScheduleDetailsSingleCard = ({
  route,
  schedule,
  index,
  totalCount,
  canManageSchedules,
  setIsLoading
}: IVehicleScheduleDetailsSingleCardProps) => {
  const { t } = useTranslation();

  const [isActionsOpen, setIsActionsOpen] = useState<MenuAnchorEl>(null);

  return (
    <SingleDetailsAcordionItem
      route={route}
      key={schedule.scheduleId}
      title={getScheduleTitle(t, schedule)}
      showGlobalIcon={schedule.global}
      totalCount={totalCount}
      index={index}
      setIsLoading={setIsLoading}
      collapsable
      anchorEl={isActionsOpen}
      setIsActionsOpen={setIsActionsOpen}
      titleInlineActions={
        canManageSchedules && (
          <>
            <ScheduleDetailsButton
              schedule={schedule}
              onActionsMenu={setIsActionsOpen}
            />
            <RemoveScheduleButton
              route={route}
              schedule={schedule}
              onActionsMenu={setIsActionsOpen}
            />
          </>
        )
      }
    >
      <ScheduleDetailsCardContent
        schedule={schedule}
        resourceName={TABLE_NAMES.Vehicles}
        //lastDownloadAttempt and lastSuccessfulDownload are going to be shown only in quick schedule until the final solution in BE is cleared out. JIRA task: TACHO-2153

        lastDownloadAttempt={schedule?.quick}
        lastSuccessfulDownload={schedule?.quick}
        currentStatus={!schedule.quick}
      />
    </SingleDetailsAcordionItem>
  );
};

export default VehicleScheduleDetailsSingleCard;
